<div class="container bg-light position-relative">
    <div class="row bg-white p-0">
        <div class="col-lg-8 bg-white p-0" [ngClass]="parentClass">
            <div class="nav-wrapper app-mob-nav-wrapper">
                <ul
                    class="nav nav-tabs nav-tabs--shadows nav-justified--mobile font-weight-bold"
                    id="tabs-left"
                    aria-label="All, live, upcoming and finished matches tabs"
                    role="tablist"
                >
                    <li
                        class="nav-item"
                        role="tab"
                        [attr.aria-controls]="'tab' + matchTab.ALL + '-content'"
                        [attr.aria-selected]="type === matchTab.ALL"
                        [attr.tabindex]="type === matchTab.ALL ? 0 : -1"
                        [attr.id]="'tab' + matchTab.ALL"
                    >
                        <a
                            class="nav-link px-3 px-md-4 active"
                            (click)="changeTab(matchTab.ALL)"
                            [class.active]="type == 'all'"
                            data-toggle="tab"
                            href="#tab1-content"
                            >{{ 'web.all_matches' | translate | transinit }}
                        </a>
                    </li>
                    <li
                        class="nav-item tab-odds"
                        [class.d-none]="!(isMobile && client.use('oddsTab') && partner.getCount() > 0 && !isInPast)"
                        role="tab"
                        [attr.aria-controls]="'tab' + matchTab.ODDS + '-content'"
                        [attr.aria-selected]="type === matchTab.ODDS"
                        [attr.tabindex]="type === matchTab.ODDS ? 0 : -1"
                        [attr.id]="'tab' + matchTab.ODDS"
                    >
                        <a
                            class="nav-link px-3 px-md-4"
                            (click)="changeTab(matchTab.ODDS)"
                            [class.active]="type == 'odds'"
                            data-toggle="tab"
                            href="#tab5-content"
                            >{{ 'web.tab_odds' | translate | transinit }}</a
                        >
                    </li>
                    <li
                        class="nav-item"
                        [class.active-live-tab]="type == 'live'"
                        role="tab"
                        [attr.aria-controls]="'tab' + matchTab.LIVE + '-content'"
                        [attr.aria-selected]="type === matchTab.LIVE"
                        [attr.tabindex]="type === matchTab.LIVE ? 0 : -1"
                        [attr.id]="'tab' + matchTab.LIVE"
                        style="position: relative"
                    >
                        <a
                            class="nav-link px-3 px-md-4 app-live-tab"
                            (click)="changeTab(matchTab.LIVE)"
                            [class.active]="type == 'live'"
                            data-toggle="tab"
                            href="#tab2-content"
                            >{{ 'web.live_matches' | translate | transinit }}
                        </a>
                        @if (numLiveMatches && numLiveMatches > 0) {
                            <span class="app-live-matches"></span>
                        }
                    </li>
                    <li
                        class="nav-item"
                        role="tab"
                        [attr.aria-controls]="'tab' + matchTab.FINISHED + '-content'"
                        [attr.aria-selected]="type === matchTab.FINISHED"
                        [attr.tabindex]="type === matchTab.FINISHED ? 0 : -1"
                        [attr.id]="'tab' + matchTab.FINISHED"
                    >
                        <a
                            class="nav-link px-3 px-md-4"
                            (click)="changeTab(matchTab.FINISHED)"
                            [class.active]="type == 'finished'"
                            data-toggle="tab"
                            href="#tab3-content"
                            data-cy="tab-finished"
                            >{{ 'web.finished_matches' | renamesportnav: sportName | translate | transinit }}</a
                        >
                    </li>
                    <li
                        class="nav-item"
                        role="tab"
                        [attr.aria-controls]="'tab' + matchTab.NOTSTARTED + '-content'"
                        [attr.aria-selected]="type === matchTab.NOTSTARTED"
                        [attr.tabindex]="type === matchTab.NOTSTARTED ? 0 : -1"
                        [attr.id]="'tab' + matchTab.NOTSTARTED"
                    >
                        <a
                            class="nav-link px-3 px-md-4"
                            (click)="changeTab(matchTab.NOTSTARTED)"
                            [class.active]="type == 'not_started'"
                            data-toggle="tab"
                            data-cy="tab-not-started"
                            href="#tab4-content"
                            >{{ 'web.future_matches' | renamesportnav: sportName | translate | transinit }}</a
                        >
                    </li>
                    @if (isTennis || hasRanking) {
                        <li
                            class="nav-item"
                            role="tab"
                            [attr.aria-controls]="'tabtabranking-content'"
                            [attr.aria-selected]="type === matchTab.RANKING"
                            [attr.tabindex]="type === matchTab.RANKING ? 0 : -1"
                            id="tabranking"
                        >
                            <a
                                class="nav-link px-3 px-md-4 app-ranking-tab"
                                id="app-ranking-tab"
                                (click)="changeTab(matchTab.RANKING)"
                                [class.active]="type == matchTab.RANKING"
                                data-toggle="tab"
                                data-cy="tab-not-started"
                                href="#tab6-content"
                                >{{ 'web.ranking' | translate | transinit }}</a
                            >
                        </li>
                    }
                    @if (!isMobile) {
                        <li
                            class="nav-item ml-auto bg-white align-items-center px-2 d-none d-md-flex app-mob-calendar"
                            [class.w-100]="isMobile"
                            role="tab"
                        >
                            <app-calendar
                                class="d-flex align-items-center"
                                (onChange)="dateChange($event)"
                            ></app-calendar>
                        </li>
                    }
                </ul>
            </div>
            <div class="d-md-none dropdown-calendar">
                <app-calendar [mobile]="true" (onChange)="dateChange($event)"></app-calendar>
            </div>
            @if (client.use('justEndedMatches') && type == 'all' && !noCategory()) {
                <app-just-ended-matches [sportId]="sportId" [sportName]="sportName"></app-just-ended-matches>
            }
            <div class="tab-content bg-white p-3 has-nomenclature position-relative">
                <div
                    class="tab-pane active"
                    [attr.id]="'tab' + type + '-content'"
                    role="tabpanel"
                    [attr.aria-labelledby]="'tab' + type"
                >
                    @if (type === 'ranking') {
                        <div class="table-sport mx-n3 mx-sm-0">
                            <app-tennis-ranking [sportName]="sportName" [sportId]="sportId"></app-tennis-ranking>
                            <app-ranking [sportName]="sportName" [sportId]="sportId"></app-ranking>
                        </div>
                    }
                    @if (type !== 'ranking') {
                        <div class="table-sport mx-n3 mx-sm-0">
                            @if (loaded) {
                                <div class="table-sport__content">
                                    @if (loadedError) {
                                        <div class="tab-pane" id="tab3-content" role="tabpanel" aria-labelledby="tab3">
                                            <div class="text-center pt-7">
                                                <svg class="icon icon--64 mb-4">
                                                    <use [attr.xlink:href]="'#icon-' + sportName" />
                                                </svg>
                                                <h4 class="font-weight-bold">{{ 'web.we_are_sorry' | translate }}</h4>
                                                <p class="mb-6">{{ 'web.error_data_load' | translate }}</p>
                                            </div>
                                        </div>
                                    } @else {
                                        @if (!noCategory()) {
                                            @if (isGroupCategory) {
                                                @for (group of categoryGroup; track $index) {
                                                    <app-category-group
                                                        [group]="group"
                                                        (groupChange)="categoryGroup[$index] = $event"
                                                    >
                                                        @if (group?.isopen && !loadedError) {
                                                            @for (
                                                                cg of categoryGroupData[group.category_id]
                                                                    | navSearch
                                                                        : 'alpha'
                                                                        : alphaFilter
                                                                        : sportId
                                                                        : sportName
                                                                    | slice: 0 : slice;
                                                                track trackByFn($index, cg)
                                                            ) {
                                                                <app-component-category
                                                                    [cg]="cg"
                                                                    [showCategoryName]="false"
                                                                    [sportId]="sportId"
                                                                    [sportName]="sportName"
                                                                    (cgChange)="load(true)"
                                                                >
                                                                    @if (cg?.isopen && !loadedError) {
                                                                        @for (
                                                                            match of categoryData[cg.sub_tournament_id];
                                                                            track trackByFn($index, match)
                                                                        ) {
                                                                            <app-component-match
                                                                                [match]="match"
                                                                                [sportName]="sportName"
                                                                                [scoreActive]="scoreActive"
                                                                                [sportId]="sportId"
                                                                                (onSelect)="loadMatch($event)"
                                                                                [dateFormat2]="'time'"
                                                                                [makeNoise]="
                                                                                    type == 'live' ? true : false
                                                                                "
                                                                            >
                                                                            </app-component-match>
                                                                        }
                                                                        @if (
                                                                            (categoryData &&
                                                                                !categoryData[cg.sub_tournament_id]) ||
                                                                            (categoryData &&
                                                                                categoryData[cg.sub_tournament_id]
                                                                                    .length == 0)
                                                                        ) {
                                                                            <div>
                                                                                <app-placeholder-match
                                                                                    [num]="oneline ? 1 : 2"
                                                                                ></app-placeholder-match>
                                                                            </div>
                                                                        }
                                                                    }
                                                                </app-component-category>
                                                            }
                                                        }
                                                    </app-category-group>
                                                }
                                            } @else {
                                                @for (
                                                    cg of data
                                                        | navSearch: 'alpha' : alphaFilter : sportId : sportName
                                                        | slice: 0 : slice2;
                                                    track trackByFn(i, cg);
                                                    let i = $index
                                                ) {
                                                    <app-component-category
                                                        [cg]="cg"
                                                        [sportId]="sportId"
                                                        [sportName]="sportName"
                                                        (cgChange)="load(true)"
                                                    >
                                                        @if (cg?.isopen && !loadedError) {
                                                            @if (isHBL && (cg.youtube_video || cg.twitch_channel)) {
                                                                @if (!cg.twitch_channel) {
                                                                    <app-youtube
                                                                        [video]="cg.youtube_video"
                                                                        [matchId]="
                                                                            categoryData[cg.sub_tournament_id]![0]!.id
                                                                        "
                                                                    ></app-youtube>
                                                                }
                                                                @if (cg.twitch_channel) {
                                                                    <app-twitch
                                                                        [channel]="cg.twitch_channel"
                                                                        [matchId]="
                                                                            categoryData[cg.sub_tournament_id]![0]!.id
                                                                        "
                                                                    ></app-twitch>
                                                                }
                                                            }
                                                            @for (
                                                                match of categoryData[cg.sub_tournament_id]
                                                                    | slice: 0 : (type == 'live' ? 99999 : (subtournamentLimits[cg.sub_tournament_id] || defaultSliceLimit));
                                                                track trackByFn($index, match)
                                                            ) {
                                                                <app-component-match
                                                                    [match]="match"
                                                                    [sportName]="sportName"
                                                                    [scoreActive]="scoreActive"
                                                                    [sportId]="sportId"
                                                                    (onSelect)="loadMatch($event)"
                                                                    [dateFormat2]="'time'"
                                                                    [makeNoise]="type == 'live' ? true : false"
                                                                >
                                                                </app-component-match>
                                                            }
                                                            @if (
                                                                (categoryData && !categoryData[cg.sub_tournament_id]) ||
                                                                (categoryData &&
                                                                    categoryData[cg.sub_tournament_id].length == 0)
                                                            ) {
                                                                <div>
                                                                    <app-placeholder-match
                                                                        [num]="oneline ? 1 : 2"
                                                                    ></app-placeholder-match>
                                                                </div>
                                                            }
                                                        }

                                                        @if (
                                                            type != 'live' &&
                                                            categoryData[cg.sub_tournament_id] &&
                                                            +cg.num_matches > (subtournamentLimits[cg.sub_tournament_id] || defaultSliceLimit)
                                                        ) {
                                                            <div
                                                                (click)="openAllMatches(cg.sub_tournament_id)"
                                                                data-toggle="collapse"
                                                                class="table-sport__subhead d-flex align-items-center py-0 bg-light bg-light-emph ng-star-inserted app-cursor text-uppercase"
                                                            >
                                                                <div
                                                                    class="table-sport__subhead__text my-2 my-sm-1 text-truncate mr-auto pr-1 text-center div-center"
                                                                >
                                                                    {{ 'web.more_results' | translate }}
                                                                </div>
                                                            </div>
                                                        }
                                                        @if (!isMobile && i === 0) {
                                                            <app-ads-container
                                                                position="universal"
                                                                [platforms]="['desktop']"
                                                            >
                                                                <app-ads universal #ads></app-ads>
                                                            </app-ads-container>
                                                        }
                                                        @if (!isMobile && i === 3) {
                                                            <app-ads-container
                                                                position="universal2"
                                                                [platforms]="['desktop']"
                                                            >
                                                                <app-ads universal #ads></app-ads>
                                                            </app-ads-container>
                                                        }
                                                        @if (isMobile && i === 0) {
                                                            <app-ads-container
                                                                position="mobile-body"
                                                                [platforms]="['mobile']"
                                                            >
                                                                <app-ads universal #ads></app-ads>
                                                            </app-ads-container>
                                                        }
                                                        @if (isMobile && i === 3) {
                                                            <app-ads-container
                                                                position="mobile-body2"
                                                                [platforms]="['mobile']"
                                                            >
                                                                <app-ads universal #ads></app-ads>
                                                            </app-ads-container>
                                                        }
                                                        @if (isMobile && i === 2) {
                                                            <app-banner-container>
                                                                <app-banner mobile-body #banners></app-banner>
                                                            </app-banner-container>
                                                        }
                                                    </app-component-category>
                                                }
                                                @if (isNotAllLoaded) {
                                                    @defer (on timer(500ms)) {
                                                        <div class="text-center w-100 py-2" id="loadingResult">
                                                            {{ 'web.loading_results' | translate }}
                                                            <i class="fas fa-spinner fa-spin"></i>
                                                        </div>
                                                    }
                                                }
                                            }
                                            @if (!loadedError && data.length == 0) {
                                                <div
                                                    class="tab-pane"
                                                    id="tab3-content"
                                                    role="tabpanel"
                                                    aria-labelledby="tab3"
                                                >
                                                    <div class="text-center pt-7">
                                                        <svg class="icon icon--64 mb-4">
                                                            <use [attr.xlink:href]="'#icon-' + sportName" />
                                                        </svg>
                                                        <h4 class="font-weight-bold">
                                                            {{ 'web.we_are_sorry' | translate }}
                                                        </h4>
                                                        <p class="mb-6">{{ 'web.no_data_found' | translate }}</p>
                                                    </div>
                                                </div>
                                            }
                                            <!-- <div class="d-flex justify-content-center py-2" *ngIf="isMoreResults()">
                              <button type="button" class="btn btn-primary" (click)="showMoreResults()">
                                {{ 'web.next_result' | translate }}
                              </button>
                            </div> -->
                                        }
                                        @if (noCategory()) {
                                            @if (type == 'all') {
                                                <div
                                                    class="tab-pane"
                                                    id="tab2-content"
                                                    role="tabpanel"
                                                    aria-labelledby="tab2"
                                                >
                                                    <div
                                                        class="text-center pt-7 app-match-no-data"
                                                        data-cy="app-match-no-data"
                                                    >
                                                        <svg class="icon icon--64 mb-4">
                                                            <use [attr.xlink:href]="'#icon-' + sportName" />
                                                        </svg>
                                                        <h4 class="font-weight-bold">
                                                            {{ 'web.we_are_sorry' | translate }}
                                                        </h4>
                                                        <p class="mb-6">
                                                            {{ 'web.no_data_found_match_list' | translate }}
                                                        </p>
                                                        @if (data.latest) {
                                                            <a
                                                                data-cy="app-match-no-data-latest"
                                                                [attr.data-cy-value]="setDate(data.latest)"
                                                                [routerLink]="['./', { date: setDate(data.latest) }]"
                                                                class="btn btn-primary mx-2 py-1 px-4"
                                                                ><span class="d-block small mb-n1"
                                                                    >{{ 'web.latest_event' | translate }}
                                                                </span>
                                                                {{ data.latest | livDate: 'localDate' }}</a
                                                            >
                                                        }
                                                        @if (data.upcoming) {
                                                            <a
                                                                [routerLink]="['./', { date: setDate(data.upcoming) }]"
                                                                class="btn btn-primary mx-2 py-1 px-4"
                                                                ><span class="d-block small mb-n1">{{
                                                                    'web.upcomming_event' | translate
                                                                }}</span>
                                                                {{ data.upcoming | livDate: 'localDate' }}</a
                                                            >
                                                        }
                                                    </div>
                                                </div>
                                            } @else {
                                                <div
                                                    class="tab-pane"
                                                    id="tab3-content"
                                                    role="tabpanel"
                                                    aria-labelledby="tab3"
                                                >
                                                    <div class="text-center pt-7">
                                                        <svg class="icon icon--64 mb-4">
                                                            <use [attr.xlink:href]="'#icon-' + sportName" />
                                                        </svg>
                                                        <h4 class="font-weight-bold">
                                                            {{ 'web.we_are_sorry' | translate }}
                                                        </h4>
                                                        @if (type == 'live') {
                                                            <p class="mb-6">
                                                                {{ 'web.no_live_tab_data_found' | translate }}
                                                            </p>
                                                        } @else {
                                                            <p class="mb-6">
                                                                {{ 'web.no_data_found_match_list' | translate }}
                                                            </p>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        }
                                        <hr />
                                        @if (isMobile) {
                                            <app-participant-comparition
                                                [sportId]="sportId"
                                                [sportName]="sportName"
                                            ></app-participant-comparition>
                                        }
                                    }
                                </div>
                            } @else {
                                <app-placeholder-match [num]="6" [withHeader]="true"></app-placeholder-match>
                            }
                        </div>
                    }
                    @if (alphaAvailLetters.length > 0) {
                        <app-alpha-filter
                            class="d-none d-lg-block"
                            [availLetters]="alphaAvailLetters"
                            (onDataChange)="alphaFilter = $event"
                        ></app-alpha-filter>
                    }
                </div>
                @if (!noCategory() && isSoccer(sportName)) {
                    <div class="pl-2">
                        <div
                            class="app-possible-goal app-possible-goal--static"
                            title="{{ 'web.possible_chance' | translate }}"
                        >
                            <div class="app-possible-goal__pulse"></div>
                        </div>
                        {{ 'web.possible_chance' | translate }}
                    </div>
                }
                @if (
                    client.use('seoCard') &&
                    ('sport-info.' + sportName | translate).search('sport-info.' + sportName) == -1
                ) {
                    <div class="app-info-card-parent card shadow border-0 mt-5">
                        <div class="app-info-card card-body p-0 p-md-5">
                            <div class="media">
                                <svg class="icon icon--32 mr-3">
                                    <use href="#icon-bulp-2" />
                                </svg>
                                <div
                                    class="media-body mt-2"
                                    [innerHTML]="'sport-info.' + sportName | translate | markdown"
                                ></div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="col-lg-4 d-none d-lg-block" [ngClass]="matchClass">
            @if (!isMobile) {
                <app-switchers
                    (onStickyChange)="onStickyChange($event)"
                    (onOpenChange)="onOpenChange($event)"
                    [options]="{ showOpenAll: true }"
                ></app-switchers>
            }
            @if (!deviceService.isMobile()) {
                <div
                    [class.sticky-parent]="stickyDetail"
                    class="col-right__inner bg-white"
                    data-cy="right-column-match"
                >
                    <app-match-detail
                        class="sticky-parent__match"
                        [class.app-match-detail--shadow]="stickyDetail"
                        [style.max-height]="viewPortHeightMatchDetail"
                        [id]="matchId"
                        [matchState]="matchState"
                        [tracker]="tracker"
                        [tabVisible]="tabVisible"
                        [stream]="stream"
                    ></app-match-detail>
                </div>
                <app-tennis-ranking [sportName]="sportName" [sportId]="sportId"></app-tennis-ranking>
                <app-ranking [sportName]="sportName" [sportId]="sportId"></app-ranking>
            }
        </div>
    </div>

    <aside class="nav-sports d-none" [class.d-xl-block]="client.use('sportQuickNav')">
        <nav class="nav flex-column bg-light">
            <app-sport-navigation
                data-cy="aside-sport"
                type="aside"
                [date]="paramDate"
                [disabled]="this.first"
                [limit]="asideLimit"
                [sportId]="sportId"
            ></app-sport-navigation>
            <a
                class="nav-link nav-link--more text-uppercase text-reset app-cursor"
                data-cy="aside-sport-toggle"
                [class.nav-link--more]="isAsideDefault()"
                [class.nav-link--less]="!isAsideDefault()"
                (click)="toggleAssideLimit()"
            >
                @if (isAsideDefault()) {
                    <span>{{ 'web.more' | translate }}</span>
                }
                @if (!isAsideDefault()) {
                    <span>{{ 'web.less' | translate }}</span>
                }
            </a>
        </nav>
    </aside>
    <aside class="nav-sports nav-sports--extra d-none" [class.d-xl-block]="client.use('sportQuickNav')">
        <nav class="nav flex-column nav-side-menu bg-light">
            <app-side-menu-navigation [sportId]="sportId" [sportName]="sportName"></app-side-menu-navigation>
        </nav>
    </aside>
</div>
@if (isMobile) {
    <app-ads-container position="mobile_layer" [platforms]="['mobile']">
        <app-ads mobile-layer #ads></app-ads>
    </app-ads-container>
}
